import json from './sprite.js';

export default {
    handle: 'es_SPT10-Candy',
    label: 'es_SPT10-Candy',
    json,
};
